import {
  PractitionerStatementEntry,
  SectionState,
} from '../../models/Entities/PractitionerAccountStatement/PractitionerAccountStatement';

/** Estado de cuenta por profesional (GUID = Practitioner.userId). No comparte nada con la caja general. */
export interface PractitionerAccountStatementState {
  byPractitioner: Record<string, PractitionerStatementEntry>;
}

const idle = <T,>(): SectionState<T> => ({ status: 'idle', data: undefined });

export const emptyStatementEntry = (): PractitionerStatementEntry => ({
  debts: idle(),
  settlementSummary: idle(),
  payments: idle(),
  settlements: idle(),
  patients: idle(),
  visits: idle(),
});

export const PractitionerAccountStatementUnloadedState: PractitionerAccountStatementState = {
  byPractitioner: {},
};
